/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceVlastnostTypDokumentu extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceVlastnostTypDokumentuObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmVlastnostTypDokumentuReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceVlastnostTypDokumentuObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000492",
                data: this.data,
                objectFields: ['ixs_typ_txt'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceVlastnostTypDokumentu",
                keys: this.keys,
                contentId: "hromadnaOperaceVlastnostTypDokumentu"
            })
        }
    }

    export class HromadnaOperaceVlastnostTypDokumentuObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmVlastnostTypDokumentuReadDto> {
        ico: string;
        typ_vps: number;

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000095").addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                    model: "model.ico=value.ico",
                    name: "ico",
                    initialValue: { ico: this.ico },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    disabled: true,
                }).addRow("jres:29932138").addField("gselectbox", Gordic.Prefabs.Select.admGincvps(), {
                    model: "model.typ_vps=value.typ_vps;model.typ_vps_txt<=value.typ_vps_txt",
                    name: "typ_vps",
                    initialValue: { typ_vps: this.typ_vps },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    disabled: true
                })
            if (this.typ_vps != null && this.typ_vps != undefined) {
                switch (this.typ_vps) {
                    case 0:
                        form.addRow("jres:33000460").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                            multi: true,
                            model: "model.ixs=value.ixs_pro;model.ixs_txt<=value.nazev",
                            name: "ixs",
                            initialValue: this.options.data.map((value) => ({ ixs_pro: value.ixs })),
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            flag: "required",
                            itemWidth: ""
                        });
                        break;
                    case 10:
                        form.addRow("jres:33000461").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                            multi: true,
                            model: "model.ixs=value.ixs_stv;model.ixs_txt<=value.nazev",
                            name: "ixs",
                            initialValue: this.options.data.map((value) => ({ ixs_stv: value.ixs })),
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            flag: "required",
                            itemWidth: ""
                        });
                        break;
                    case 20:
                        form.addRow("jres:33000455").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                            multi: true,
                            model: "model.ixs=value.ixs_vla;model.ixs_txt<=value.nazev",
                            name: "ixs",
                            initialValue: this.options.data.map((value) => ({ ixs_vla: value.ixs })),
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            flag: "required",
                            itemWidth: ""
                        });
                        break;
                }
            } else {
                form.addRow("jres:33000455").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                    multi: true,
                    model: "model.ixs_vla=value.ixs_vla;model.ixs_vla_txt<=value.nazev",
                    name: "ixs",
                    initialValue: this.options.data.map((value) => ({ ixs_vla: value.ixs })),
                    itemWidth: ""
                }).addRow("jres:33000461").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                    multi: true,
                    model: "model.ixs_stv=value.ixs_stv;model.ixs_stv_txt<=value.nazev",
                    name: "ixs",
                    itemWidth: ""
                }).addRow("jres:33000460").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                    multi: true,
                    model: "model.ixs_pro=value.ixs_pro;model.ixs_pro_txt<=value.nazev",
                    name: "ixs_pro",
                    itemWidth: ""
                })
            }
            if (this.typ_vps != null && this.typ_vps != undefined) {
                form.addRow("jres:30011510").addField("gselectbox", Gordic.Prefabs.Select.sslstyp(), {
                    multi: true,
                    model: "model.ixs_typ=value.ixs_typ;model.ixs_typ_txt<=value.nazev",
                    name: "ixs_typ",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    itemWidth: ""
                })
            }
            form.addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                name: "aktivita",
                model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                initialValue: { aktivita: 100 },
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
            })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs", "ixs_txt"]), this.transformDataToArrayObject(formData, ["ixs_typ", "ixs_typ_txt"]));
            var resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    ixs: item[0]["ixs"],
                    ixs_txt: item[0]["ixs_txt"],
                    ixs_typ: item[1]["ixs_typ"],
                    ixs_typ_txt: item[1]["ixs_typ_txt"],
                    typ_vps: formData["typ_vps"],
                    typ_vps_txt: formData["typ_vps_txt"],
                    aktivita: formData['aktivita'],
                    ico: formData['ico']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            this.createAktivitaColumn(gridFormat);
            gridFormat.addTextColumn({
                caption: "jres:29932138",
                name: "typ_vps_txt",
            }).addTextColumn({
                caption: "jres:33000428",
                name: "ixs_txt",
            }).addTextColumn({
                caption: "jres:30011510",
                name: "ixs_typ_txt",
            }).addTextColumn({
                caption: "jres:33000095",
                name: "ico",
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmVlastnostTypDokumentuSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    ixs: item['ixs'],
                    ixs_typ: item['ixs_typ'],
                    ico: item['ico'],
                    typ_vps: item['typ_vps'],
                    aktivita: item['aktivita'],
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}